import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import en from '../../messages/en.json'
import pl from '../../messages/pl.json'

// One-time migration: earlier builds detected the browser's UI language via `navigator`
// and auto-persisted it (often `en`) into localStorage/cookie, which stuck users on
// English. There is no in-app language switcher yet, so any stored value was set
// automatically, not chosen — clear it once so the `pl` default applies. A future
// explicit switch will persist normally and won't be touched again.
const LANG_RESET_FLAG = 'i18nLangReset_v1'
if (typeof window !== 'undefined' && !window.localStorage.getItem(LANG_RESET_FLAG)) {
	window.localStorage.removeItem('i18nextLng')
	// biome-ignore lint/suspicious/noDocumentCookie: one-shot cleanup of a legacy language cookie; CookieStore is async and unsupported in Safari
	document.cookie = 'i18next=; Max-Age=0; path=/'
	window.localStorage.setItem(LANG_RESET_FLAG, '1')
}

function applyDocumentMetadata() {
	if (typeof document === 'undefined') {
		return
	}

	document.documentElement.lang = i18n.resolvedLanguage ?? 'pl'
	document.querySelector('meta[name="description"]')?.setAttribute('content', i18n.t('app.description'))
}

void i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: { translation: en },
			pl: { translation: pl },
		},
		fallbackLng: 'pl',
		interpolation: {
			escapeValue: false,
		},
		detection: {
			// Polish is the default; only an explicit cookie/localStorage preference switches
			// away from it. `navigator` is intentionally omitted so the browser's UI language
			// no longer forces English.
			order: ['cookie', 'localStorage'],
		},
	})
	.then(applyDocumentMetadata)

i18n.on('languageChanged', () => {
	window.location.reload()
})

export default i18n
